<template>
  <table border="1" class="custom-gantt-body">
    <template v-if="ganntHeaderMode === 'day'">
      <tr v-for="(day, index) in bodyData.length" :key="index">
        <template v-for="item in headerData">
          <template v-for="(subitem, monthIndex) in item.children">
            <td v-for="(day, index) in subitem.dayList" :key="index">
              <div class="size"></div>
            </td>
          </template>
        </template>
      </tr>
    </template>

    <template
      v-else-if="ganntHeaderMode === 'week' || ganntHeaderMode === 'month'"
    >
      <tr v-for="(day, index) in bodyData.length" :key="index">
        <template v-for="item in headerData">
          <template
            v-for="(subitem, subitemIndex) in item.end - item.start + 1"
            :key="subitemIndex"
          >
            <td>
              <div class="size" :class="[setClassName(ganntHeaderMode)]"></div>
            </td>
          </template>
        </template>
      </tr>
    </template>
  </table>
</template>

<script>
import { defineComponent, inject, reactive, watch } from "vue";

export default defineComponent({
  props: {
    body: Object,
    header: Object,
  },
  setup(props, context) {
    const ganntHeaderMode = inject("ganntHeaderMode");

    const headerData = reactive([]);
    const bodyData = reactive([]);

    const setClassName = (mode) => {
      const MODECLASSNAME = {
        week: "",
        month: "month-mode",
      };

      const className = MODECLASSNAME[mode];

      if (className) {
        return className;
      }

      return "";
    };

    watch(
      () => props.body,
      (val) => {
        bodyData.length = 0;
        bodyData.push(...val);
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.header,
      (val) => {
        headerData.length = 0;
        headerData.push(...val);
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      headerData,
      bodyData,
      setClassName,
      ganntHeaderMode,
    };
  },
});
</script>

<style lang="less" scoped>
table tr:nth-child(6n + 1),
table tr:nth-child(6n + 2),
table tr:nth-child(6n + 3) {
  background-color: #e7eefc;
}
.custom-gantt-body {
  .stripe {
    background: #d9e1f2;
  }
  td {
    padding: 0;
    .size {
      height: 30px;
      width: 30px;
      text-align: center;
      line-height: 30px;
    }
    .month-mode {
      width: 74px;
    }
  }
}
</style>
